var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "qr-code-color-wrapper" },
    [
      _vm._l(_setup.visibleColorItems, function (item) {
        return _c(_setup.QrColorPicker, {
          key: item.key,
          attrs: {
            label: item.label,
            color: _setup.model[item.key],
            disabled: _setup.disabled,
          },
          on: {
            "color-selected": (color) =>
              _setup.onColorSelected(item.key, color),
          },
        })
      }),
      _vm._v(" "),
      _c(_setup.CCheckbox, {
        attrs: {
          value: _setup.model.transparentBackground,
          label: "Transparent background",
          disabled: _setup.disabled,
        },
        on: { input: _setup.onTransparentBackgroundToggled },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }